import { zervantSettingsQueryKey } from '@features/invoicingSettings/constants/zervantSettingsQueryKey'
import { useUpdateZervantSettings } from '@features/invoicingSettings/hooks/useUpdateZervantSettings'
import { useZervantSettings } from '@features/invoicingSettings/hooks/useZervantSettings'
import { getPaymentMethodsPayload } from '@features/invoicingSettings/modules/paymentsAndReminders'

import { queryClient } from '../../../../../../../config/queryClient'
import { QueryKeys } from '../../../../../../../enums/queryKeys'
import { InvoiceSettingsForm } from '../types/invoiceSettingsForm'
import { getCompanyPayload } from '../utils/invoiceSettingsPayload/getCompanyPayload'
import { getModelsPayload } from '../utils/invoiceSettingsPayload/getModelsPayload'

export const useUpdateInvoiceSettings = () => {
  const { data: zervantSettings } = useZervantSettings()
  const { update, isProcessing } = useUpdateZervantSettings()

  const updateInvoiceSettings = (formData: InvoiceSettingsForm) => {
    if (!zervantSettings || isProcessing) {
      return
    }

    update(
      {
        models: getModelsPayload(zervantSettings.models, formData),
        values: {
          ...zervantSettings.values,
          company: getCompanyPayload(zervantSettings.values.company, formData),
          paymentMethods: getPaymentMethodsPayload(zervantSettings.values.paymentMethods, formData.paymentMethods),
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(zervantSettingsQueryKey)
          queryClient.invalidateQueries(QueryKeys.ZervantInvoiceLogo)
        },
      },
    )
  }

  return { update: updateInvoiceSettings, isProcessing }
}
